'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstOutgoingMessage = exports.getHasOutgoingMessages = exports.getIsPublishing = exports.getOutgoingMessageQueue = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOutgoingMessageQueue = exports.getOutgoingMessageQueue = (0, _getIn2.default)(['outgoingMessages', 'queue']);

var getIsPublishing = exports.getIsPublishing = function getIsPublishing(state) {
  return Boolean((0, _getIn2.default)(['outgoingMessages', 'publishing'], state));
};

var getHasOutgoingMessages = exports.getHasOutgoingMessages = (0, _reselect.createSelector)(getOutgoingMessageQueue, function (outgoingMessages) {
  return Boolean(outgoingMessages.size);
});

var getFirstOutgoingMessage = exports.getFirstOutgoingMessage = (0, _reselect.createSelector)(getOutgoingMessageQueue, function (outgoingMessages) {
  return outgoingMessages.first();
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/outgoingMessagesSelectors.js
// module id = 95
// module chunks = 0 1